<template>
  <div>
    <a-card size="small" :loading="loading">
      <a-page-header :title="data.title" :sub-title="`${data.start_date} ~ ${data.end_date}`">
        <template slot="extra">
          <noticeboard-push v-has="{ code: 'data:noticeboard:push' }" :source-id="sourceId" :source-data="data" />
          <a-button key="1" v-has="{ code: 'data:noticeboard:edit' }" v-tc="{ name: '编辑' }" type="primary" @click="onEdit"> 编辑 </a-button>
        </template>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="创建人"> {{ data.creator ? data.creator.nickname : '--' }} </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ data.created_time }}</a-descriptions-item>
          <a-descriptions-item label="更新时间">{{ data.updated_time }}</a-descriptions-item>
          <a-descriptions-item label="参与项目">{{ data.projects ? data.projects.map(item => item.name).join('; ') : '--' }}</a-descriptions-item>
          <a-descriptions-item label="备注信息" :span="2">{{ data.description }}</a-descriptions-item>
        </a-descriptions>
      </a-page-header>

      <a-tabs v-model="activeKey" size="small">
        <a-tab-pane key="1" tab="质效得分">
          <a-table size="small" :pagination="false" :columns="columns" row-key="index" :data-source="team_data" bordered>
            <template slot="team" slot-scope="text, record"> {{ record.team_info.team_name }} </template>
            <template slot="timeQuality" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <NoticeboardVersion :data-source="record.version.versions" />
                </template>
                <span>{{ record.version ? record.version.score : 0 }} 分 </span>
              </a-popover>
            </template>
            <template slot="averageWorkload" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <div>{{ record.task ? `${record.task.points} point / ${record.working_time}人/天 = ${record.task.average_workload}人天` : '--' }}</div>
                  <div>加班: {{ record.overtime_works }}天，请假: {{ record.leaves }}天</div>
                </template>
                <p>{{ record.task ? `${record.task.average_workload}人天` : '--' }}</p>
              </a-popover>
              <p>{{ record.task ? record.task.score : 0 }} 分</p>
            </template>
            <template slot="releasePassedRate" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <div>{{ record.release ? `${record.release.passed} / ${record.release.total}` : '--' }}</div>
                </template>
                <p>{{ record.release ? `${record.release.passed_rate} %` : '--' }}</p>
              </a-popover>
              <p>{{ record.release ? record.release.score : 0 }} 分</p>
            </template>
            <template slot="issueResponse" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <h4>{{ record.issue ? `${record.issue.total_response_time_str} / ${record.issue.total_number}个` : '--' }}</h4>
                  <noticeboard-issue :data-source="record.issue.issues" />
                </template>
                <p>{{ record.issue ? `${record.issue.avg_response_time_str}` : '--' }}</p>
              </a-popover>
              <p>{{ record.issue ? record.issue.score : 0 }} 分</p>
            </template>
            <template slot="defectDensity" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <div>{{ record.defect_density ? `${record.defect_density.issue_total_number} / ${record.defect_density.points}` : '--' }}</div>
                </template>
                <p>{{ record.defect_density ? `${record.defect_density.defect_density} %` : '--' }}</p>
              </a-popover>
              <p>{{ record.defect_density ? record.defect_density.score : 0 }} 分</p>
            </template>
            <template slot="totalScore" slot-scope="text, record"> {{ record.total_score }} 分</template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="数据修正">
          <correction-apply-modal style="float: left" :data-source="team_data" :source-id="sourceId" @close="close" />
          <data-correction-list style="float: left" :data-source="data.data_correction" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <noticeboard-modal :display="visible" :source-id="sourceId" :source-data="formData" @close="close" />
  </div>
</template>
<script>
import { noticeboardDetail } from '@/api/data/noticeboard';
import NoticeboardIssue from '@/pages/data/components/NoticeboardIssue';
import NoticeboardModal from '@/pages/data/components/NoticeboardModal';
import DataCorrectionList from '@/pages/data/components/DataCorrectionList';
import NoticeboardVersion from '@/pages/data/components/NoticeboardVersion';
import CorrectionApplyModal from '@/pages/data/components/CorrectionApplyModal';
import NoticeboardPush from '@/pages/data/components/NoticeboardPush';

const columns = [
  {
    title: '团队',
    align: 'center',
    scopedSlots: { customRender: 'team' }
  },
  {
    title: '时量分布',
    align: 'center',
    scopedSlots: { customRender: 'timeQuality' }
  },
  {
    title: '工作量/人均Point(人/天)',
    align: 'center',
    scopedSlots: { customRender: 'averageWorkload' }
  },
  {
    title: '提审通过率',
    align: 'center',
    scopedSlots: { customRender: 'releasePassedRate' }
  },
  {
    title: '缺陷(开发)响应平均耗时',
    align: 'center',
    scopedSlots: { customRender: 'issueResponse' }
  },
  {
    title: '缺陷密度',
    align: 'center',
    scopedSlots: { customRender: 'defectDensity' }
  },
  {
    title: '质效总分',
    align: 'center',
    scopedSlots: { customRender: 'totalScore' }
  }
];
export default {
  components: { NoticeboardModal, DataCorrectionList, NoticeboardVersion, CorrectionApplyModal, NoticeboardIssue, NoticeboardPush },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      columns,
      loading: true,
      visible: false,
      activeKey: '1',
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []
    };
  },
  watch: {
    sourceId() {
      this.getNoticeboardDetail();
    }
  },
  created() {
    this.getNoticeboardDetail();
  },
  methods: {
    getNoticeboardDetail() {
      if (this.sourceId !== null) {
        this.loading = true;
        noticeboardDetail({ id: this.sourceId })
          .then(res => {
            this.data = res.data;
            this.team_data = res.data.content.team_data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    onEdit() {
      this.visible = true;
      this.formData = {
        title: this.data.title,
        projects: this.data.projects,
        start_date: this.data.start_date,
        end_date: this.data.end_date,
        description: this.data.description,
        params: this.data.params || {}
      };
    },
    close(type = 'cancel') {
      this.visible = false;
      if (type !== 'cancel') {
        this.getNoticeboardDetail();
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
